// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const iatSummarySchema = z.object({
  "id": z.string().uuid(),
  "label": z.string(),
  "max_registrations": z.number().int().min(1).optional(),
  "used_count": z.number().int().min(0),
  "expires_at": z.string().datetime({ offset: true }).optional(),
  "revoked_at": z.string().datetime({ offset: true }).optional(),
  "last_used_at": z.string().datetime({ offset: true }).optional(),
  "last_used_ip": z.string().optional(),
  "created_at": z.string().datetime({ offset: true })
}).strict();

export const iatListResponseSchema = z.object({
  "items": z.array(iatSummarySchema).max(200),
  "total": z.number().int().min(0)
}).strict();

export const mintIATResponseSchema = z.object({
  "token": z.string(),
  "summary": iatSummarySchema
}).strict();

export const dcrPolicySchema = z.object({
  "open_registration_enabled": z.boolean(),
  "allowed_redirect_uri_suffixes": z.array(z.string()).optional(),
  "min_token_endpoint_auth_method": z.enum(["none", "client_secret_post", "client_secret_basic", "private_key_jwt"]).optional(),
  "updated_at": z.string().datetime({ offset: true }).optional()
}).strict();

export const registrationReviewSchema = z.object({
  "id": z.string().uuid(),
  "application_id": z.string().uuid(),
  "application_name": z.string(),
  "client_id": z.string(),
  "redirect_uris": z.array(z.string()),
  "token_endpoint_auth_method": z.string(),
  "allowed_scopes": z.array(z.string()),
  "initial_access_token_id": z.string().uuid().optional(),
  "initial_access_token_label": z.string().optional(),
  "source": z.enum(["iat", "open_registration"]),
  "state": z.enum(["pending", "approved", "rejected"]),
  "software_id": z.string().optional(),
  "software_version": z.string().optional(),
  "remote_ip": z.string().optional(),
  "submitted_at": z.string().datetime({ offset: true }),
  "reviewed_at": z.string().datetime({ offset: true }).optional(),
  "reviewed_by": z.string().uuid().optional(),
  "rejection_reason": z.string().optional(),
  "version": z.number().int().min(1)
}).strict();

export const registrationReviewListSchema = z.object({
  "items": z.array(registrationReviewSchema).max(200),
  "total": z.number().int().min(0)
}).strict();
